import settingsReducer from './settingsReducer';

export * from './settingsActionTypes';
export default settingsReducer;
